jQuery(document).ready(function($){



  if ($('.change-bundle-variant-id').length){

    $.each($('.change-bundle-variant-id'),function(){

      var dataSku = $(this).attr('data-sku');
      var dataVariantID = $(this).attr('data-variant-id');

      var target = $('.bundle-variant[data-variant-sku="'+dataSku+'"]');
      
      target.find('.btn-quick-add').attr('data-variant-id',dataVariantID);
      target.find('.quantity').attr('data-variant-id',dataVariantID);
      target.attr('data-variant-id',dataVariantID);
      target.addClass('change-variant-id');

    });


  }
  


  if (!$('.product-bundle-save').length){
    const swiperProductImages = new Swiper('.swiper-product-images', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1000,
      navigation: {
        nextEl: '.swiper-product-images .swiper-button-next',
        prevEl: '.swiper-product-images .swiper-button-prev',
      },
      pagination: {
        el: '.swiper-product-images .swiper-pagination',
        clickable: true,
      },
    });
  }


function initGallery($gallery) {
    $gallery.on('click', 'img, video', function (e) {
      e.preventDefault();

      var $clicked = $(this);
      // Scope to THIS gallery only
      var $items = $gallery.find('img, video');

      var items = $items.map(function () {
        var $el = $(this);

        // VIDEO ITEM
        if ($el.is('video')) {
          return {
            html:
              '<div style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;">' +
                '<video autoplay muted loop playsinline preload="auto" ' +
                'style="max-width:100%;max-height:100%;width:auto;height:auto;">' +
                  '<source src="' + $el.find('source').attr('src') + '" type="video/mp4">' +
                  'Your browser does not support the video tag.' +
                '</video>' +
              '</div>',
            w: 1920,
            h: 1080
          };
        }

        // IMAGE ITEM
        var imgSrc = $el.data('large') || $el.attr('src');
        var img = new Image();
        img.src = imgSrc;

        return {
          src: imgSrc,
          w: img.naturalWidth || $el[0].naturalWidth || 1920,
          h: img.naturalHeight || $el[0].naturalHeight || 1080
        };
      }).get();

      var index = $items.index($clicked);
      var pswpElement = document.querySelector('.pswp');

      var options = {
        index: index,
        bgOpacity: 0.9,
        showHideOpacity: true
      };

      var lightbox = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      lightbox.init();
    });
  }

  // Desktop gallery
  initGallery($('.gallery-desktop, .product-supporting'));

  // Mobile gallery
  initGallery($('.gallery-mobile'));


  if ($(window).outerWidth() >= 768){
    $('.design-c-product-gallery').stickySidebar({
        topSpacing: 20,
        bottomSpacing: 20
    });
  }

  const hallOfSame = new Swiper('.swiper-hall-of-fame', {
    direction: 'vertical',
    slidesPerView: 5, // Default for desktop
    spaceBetween: 30,
    autoHeight: true,
    loop: true,
    speed: 3000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    allowTouchMove: true,
    freeMode: true,
  
    pagination: {
      el: '.swiper-hall-of-fame .swiper-pagination',
      clickable: true,
    },
  
    // 👉 Add this for responsive behavior
    breakpoints: {
      0: { // Mobile (0px and up)
        slidesPerView: 3,
      },
      768: { // Tablet and up
        slidesPerView: 5,
      }
    }
  });


  const swiper = new Swiper('.swiper-videos', {
    loop: true,
    slidesPerView: 4, // Default for mobile-first (smallest screens)
    spaceBetween: 30,
    speed: 300,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      556: {
        slidesPerView: 1.2, // Small screens ≤ 556px
      },
      768: {
        slidesPerView: 3, // Tablets ≤ 768px
      },
      1024: {
        slidesPerView: 4, // Larger screens (default)
      },
    },
  });


  const experts = new Swiper('.swiper-design-c-experts', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    effect: 'fade',
    speed: 2000, // ⏳ 2s fade transition
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000, // ⏱ stays for 5s before transitioning
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-design-c-experts .swiper-pagination",
      clickable: true,
    }
});
  
  const addToCartSwiper = new Swiper('.swiper-add-to-cart-carousel', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true, // keep enabled for soft transition
    },
    loop: true,
    speed: 700, // shorter fade duration
    autoplay: {
      delay: 2000, // longer time before next transition
      disableOnInteraction: false,
    },
  });
    
  
  

  
  var cartDrawer =  $('.fon-cart-drawer');
  var addToCartButton = $('#btn-add-to-cart');
  
  // packaging-group
  $(document).on('click','.packaging-group',function(){
    $(this).siblings().removeClass('activated');
    $(this).addClass('activated');
  });

  // packaging-group qty
  $(document).on('click','.quantity-picker .qty',function(){

    if ($(this).hasClass('active')){
      $(this).removeClass('active');
    }else{
      $(this).parents('.quantity-picker').find('.qty').removeClass('active');
      $(this).addClass('active');
    }
    
    computeActiveQuantity();
  });

  


  

  function computeActiveQuantity(){

    var total = 0;

    $.each($('.quantity-picker .qty.active'),function(){

      total+= parseFloat($(this).attr('data-qty'));
      
    });

    $('.cart-goal,.goal-progress').removeClass('matched');
    $('.cart-goal,.goal-progress').removeClass('active');
    $('.cart-goal,.goal-progress').removeClass('last-matched');
    
    $('.cart-goal,.goal-progress').each(function (index) {
      var spendValue = parseInt($(this).attr('data-quantity'), 10);
    
      if (total >= spendValue) {
        $(this).addClass('matched'); // optional: add class to highlight
      }
    });

    var lastMatched = $('.goals .cart-goal.matched').last();
    lastMatched.addClass('last-matched'); // Optional: mark or style it

    var lastMatched = $('.goals-progress > div.matched').last();
    lastMatched.addClass('last-matched'); // Optional: mark or style it
    
    $(".goals,.goals-progress").attr('data-matched',$('.cart-goal').length);

    if (total > 0){
      addToCartButton.prop('disabled',false);
    }else{
      addToCartButton.prop('disabled',true);
    }
    
  }


 

  // Open Cart Drawer
  addToCartButton.on('click','',function(){
    
    addToCart();
    
  });

  function addToCart(){



    addToCartButton.html('Please wait..').prop('disabled',true);
    
    var items = [];
    

    var variantId = $('.fon-quick-quantity-selector .quantity').data('variant-id');
    var qty = $('.fon-quick-quantity-selector .quantity').data('value');
    
    if (variantId) {
      items.push({
        id: variantId,
        quantity: qty
      });
    }

    if (items.length > 0) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          items: items
        },
        dataType: 'json',
        success: function(response) {
          console.log('Items added:', response);

          FonCartDrawer.openCartDrawer();
          FonCartDrawer.updateCartDrawer();
          addToCartButton.html('Add To Cart').prop('disabled',false);
          computePrice(qty); // New component
          
          
        },
        error: function(error) {
          console.error('Error adding items:', error);
          addToCartButton.html('Something went wrong...').prop('disabled',false);
        }
      });
    }

    // addToCartButton.html('Please wait..').prop('disabled',true);
    
    
    
    // var items = [];
    
    // $('.quantity-picker .qty.active').each(function() {
    //   var variantId = $(this).data('variant-id');
    //   var qty = $(this).data('qty');
      
    //   if (variantId) {
    //     items.push({
    //       id: variantId,
    //       quantity: qty
    //     });
    //   }
    // });
    
    // if (items.length > 0) {
    //   $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: {
    //       items: items
    //     },
    //     dataType: 'json',
    //     success: function(response) {
    //       console.log('Items added:', response);

    //       FonCartDrawer.openCartDrawer();
    //       FonCartDrawer.updateCartDrawer();
    //       addToCartButton.html('Add To Cart').prop('disabled',false);
          
          
    //     },
    //     error: function(error) {
    //       console.error('Error adding items:', error);
    //       addToCartButton.html('Something went wrong...').prop('disabled',false);
    //     }
    //   });
    // }
  }


  
  
  


  
  $('.popup-inline-bottom-animation').magnificPopup({
    type: 'inline',
    callbacks: {
          open: function() {
              console.log('Popup body-inline-bottom');
              $('body').addClass('body-popup-slide');
          },
          close: function() {
              console.log('Popup closed');
              $('body').removeClass('body-popup-slide');
          }
    },
    mainClass: 'mfp-animate-bottom',
    closeMarkup: `
      <button title="%title%" type="button" class="mfp-close">
        <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
          <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
        </svg>
      </button>
    `
  });

  // Benefits Item Toggle
  $(document).on('click','.benefits .item',function(){

    if ($(this).hasClass('active')){
      $(this).removeClass('active');
    }else{
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
    }
    
  });


  function moveProductImages() {
    if ($(window).width() < 768) {
      // Move children from desktop to mobile if not already moved
      if ($('.product-desktop-images').children().length && $('.product-mobile-images').children().length === 0) {
        $('.product-desktop-images').children().appendTo('.product-mobile-images');
      }
    } else {
      // Move them back from mobile to desktop
      if ($('.product-mobile-images').children().length && $('.product-desktop-images').children().length === 0) {
        $('.product-mobile-images').children().appendTo('.product-desktop-images');
      }
    }
  }

  // Initial check
  moveProductImages();

  // On resize
  $(window).resize(function () {
    moveProductImages();
  });
  


  //   new Swiper('.product-gallery-swiper', {
  //     loop: true,
  //     slidesPerView: 1,
  //     spaceBetween: 0,
  //     pagination: false,
  //     navigation: false,
  //     allowTouchMove: true
  //   });




  // First available QTY
  // chec ..packaging-group.sachets

  if ($('.packaging-group.sachets .quantity-picker .qty').length){
    var firstQuantityPicker = $('.packaging-group.sachets .quantity-picker .qty').first();
    firstQuantityPicker.parents('.packaging-group').addClass('activated');
    firstQuantityPicker.trigger('click');
  }else{
    var firstQuantityPicker = $('.quantity-picker .qty').first();
    firstQuantityPicker.parents('.packaging-group').addClass('activated');
    firstQuantityPicker.trigger('click');
  }
  
  
 

  
  $(document).on('click','.inside-onefit-tabs .tab',function(){
    var dataAction = $(this).attr('data-action');

    $('.inside-onefit-tabs-content .tab-content').removeClass('active');
    $('.inside-onefit-tabs-content .tab-content[data-action="'+dataAction+'"]').addClass('active');

    $('.inside-onefit-tabs  .tab').removeClass('active');
    $(this).addClass('active');
  });


  function initExploreProducts(key, slidesPerView = 1.2) {
    const parentElement = $(key);
  
    if ($(window).width() <= 768 && !parentElement.hasClass('swiper-initialized')) {
      // Add Swiper classes
      parentElement.addClass('swiper-container swiper-initialized');
      parentElement.children().wrapAll('<div class="swiper-wrapper"></div>');
      parentElement.find('.swiper-wrapper').children().addClass('swiper-slide');
  
      new Swiper(key, {
        slidesPerView: slidesPerView,
        spaceBetween: 10,
        loop: true,
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: key + ' .swiper-pagination',
          clickable: true,
        }
      });
      // Add pagination if not exists
      if (!parentElement.find('.swiper-pagination').length) {
        parentElement.append('<div class="swiper-pagination"></div>');
      }

      
    } else if ($(window).width() > 768 && parentElement.hasClass('swiper-initialized')) {
      // Destroy Swiper instance and reset structure
      parentElement.removeClass('swiper-container swiper-initialized');
      const slides = parentElement.find('.swiper-slide').unwrap(); // unwrap from swiper-wrapper
      slides.removeClass('swiper-slide');
      parentElement.find('.swiper-pagination').remove();
    }
  }
  initExploreProducts('#design-c-explore-products .row',1.3);


  function isMobile() {
    return window.innerWidth <= 768; // Adjust for your mobile breakpoint
  }


  

  


  $(document).on('click','.quick-view',function(){
    $('.quick-view').removeClass('active');
    $(this).addClass('active');
   
    // Open directly via API
    $.magnificPopup.open({
      callbacks: {
            open: function() {
                console.log('Popup body-inline-bottom');
                $('body').addClass('body-popup-slide');
            },
            close: function() {
                console.log('Popup closed');
                $('body').removeClass('body-popup-slide');
            }
      },
      mainClass: 'mfp-animate-bottom',
      items: {
        src: '<div class="white-popup bundle-quick-view">' + $(this).siblings('.quick-view-content-container').html() +'</div>', // can be a HTML string, jQuery object, or CSS selector
        type: 'inline'
      }
    });


  });


  // function checkAddToCartVisibility() {
  //   var $target = $('.hasta-certified');

  //   if ($target.length === 0) return;

  //   var rect = $target[0].getBoundingClientRect();
  //   var isVisible = rect.top < window.innerHeight;

  //   if (isVisible && isMobile()) {
  //     $('body').addClass('add-to-cart-visible');
  //   } else {
  //     $('body').removeClass('add-to-cart-visible');
  //   }
  // }

  // $(window).on('scroll resize', function () {
  //   checkAddToCartVisibility();
  // });

  // checkAddToCartVisibility(); // Initial check
  



  /*
  * Name: Hide the subscription widget based from customer's ip address country location
  * Fallback: Shopify market geo redirect
  */
  $(window).on('load', function () {
    $('body').removeClass('body-non-au');
  
    const apiKey = '6be9e5e33b3f9ee33ee7ebd401a82a65472dc1f1';
    const geoApiUrl = `https://api.getgeoapi.com/v2/ip/check?api_key=${apiKey}&format=json`;
    const allowedCountries = ['AU','NZ','PH'];
    const storageKey = 'user_country_code';
    const expiryKey = 'user_country_code_expiry';
    const ttlHours = 4;
  
    function applySubscriptionChanges() {
      $('body').addClass('body-non-au');
    }
  
    function handleCountry(countryCode) {
      console.log(`[handleCountry] Country code is "${countryCode}".`);
      if (!allowedCountries.includes(countryCode)) {
        console.log(`[handleCountry] "${countryCode}" is NOT allowed. Applying changes.`);
        applySubscriptionChanges();
      } else {
        console.log(`[handleCountry] "${countryCode}" is allowed (AU or PH). No changes needed.`);
      }
    }
  
    function isExpired() {
      const expiry = localStorage.getItem(expiryKey);
      const now = Date.now();
      if (!expiry) {
        console.log('[isExpired] No expiry found in localStorage.');
        return true;
      }
      const isExpired = now > parseInt(expiry, 10);
      console.log(`[isExpired] Now: ${now}, Expiry: ${expiry}, Expired: ${isExpired}`);
      return isExpired;
    }
  
    function saveCountryToStorage(countryCode) {
      const expiryTime = Date.now() + ttlHours * 60 * 60 * 1000;
      localStorage.setItem(storageKey, countryCode);
      localStorage.setItem(expiryKey, expiryTime.toString());
      console.log(`[saveCountryToStorage] Stored "${countryCode}" with expiry at ${new Date(expiryTime).toLocaleString()}`);
    }
  
    function fetchAndStoreCountry() {
      console.log('[fetchAndStoreCountry] Fetching country via GeoAPI...');
      $.getJSON(geoApiUrl)
        .done(function (data) {
          let countryCode = null;
  
          if (data.status === 'success' && data.country && data.country.code) {
            countryCode = data.country.code;
            console.log(`[GeoAPI] Success: Country code from API: "${countryCode}"`);
          } else if (typeof Shopify !== 'undefined' && Shopify.country) {
            countryCode = Shopify.country;
            console.log(`[GeoAPI] Failed. Fallback to Shopify.country: "${countryCode}"`);
          } else {
            console.log('[GeoAPI] No country code found.');
          }
  
          if (countryCode) {
            saveCountryToStorage(countryCode);
            handleCountry(countryCode);
          }
        })
        .fail(function () {
          console.warn('[GeoAPI] API call failed.');
          if (typeof Shopify !== 'undefined' && Shopify.country) {
            const fallbackCountry = Shopify.country;
            console.log(`[GeoAPI] Fallback to Shopify.country: "${fallbackCountry}"`);
            saveCountryToStorage(fallbackCountry);
            handleCountry(fallbackCountry);
          } else {
            console.warn('[GeoAPI] No fallback available.');
          }
        });
    }
  
    const storedCountry = localStorage.getItem(storageKey);
  
    if (storedCountry && !isExpired()) {
      console.log(`[LocalStorage] Found valid country: "${storedCountry}".`);
      handleCountry(storedCountry);
    } else if (storedCountry && isExpired()) {
      console.log('[LocalStorage] Expired data. Fetching new data...');
      fetchAndStoreCountry();
    } else {
      console.log('[LocalStorage] No data found. Fetching...');
      fetchAndStoreCountry();
    }
  });





  //  $(document).on('click','[data-notify-me]',function(){

  //     var variantID = $(this).attr('data-variant-id');
    
  //     $.magnificPopup.open({
  //       items: {
  //         src: '#klaviyo-oos-' + variantID // This is the ID of the hidden div
  //       },
  //       type: 'inline'
  //     });

  // });


  const swiperCompetitionSlider = new Swiper('.swiper-competition-slider', {
    slidesPerView: 1.3, // show partial next/prev
    spaceBetween: 0,
    centeredSlides: true,
    initialSlide: 0, // ✅ Force it to start at the first slide
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      567: {
        spaceBetween: 20,
        slidesPerView: 3,
        centeredSlides: false,
      },
    }
  });

  $(document).on('click','.competition-nav .nav-item',function(){
    $(this).siblings().removeClass('active');
    $(this).addClass('active');

    var action = $(this).attr('data-action');
    $('.competition-tab').removeClass('active');
    $('.competition-tab[data-tab="'+action+'"]').addClass('active');

    swiperCompetitionSlider.slideTo(0);
    
  });


  if (window.innerWidth <= 768) {
    var $hallSection = $('#section-design-c-hall').closest('.shopify-section');
    var $featureReviewSection = $('#design-c-feature-review').closest('.shopify-section');

    if ($hallSection.length && $featureReviewSection.length) {
      $hallSection.insertAfter($featureReviewSection);
    }

    var $hallSection = $('#design-c-difference').closest('.shopify-section');
    var $featureReviewSection = $('#design-c-compete').closest('.shopify-section');

    if ($hallSection.length && $featureReviewSection.length) {
      $hallSection.insertAfter($featureReviewSection);
    }
    


  }




  $(document).on('click', '.fon-quick-quantity-selector .quick-btn', function (e) {

    var parent = $(this).parents('.fon-quick-quantity-selector');
    var quantity = parent.find('.quantity');
    var label = parent.find('.label');
    var action = $(this).attr('data-action');

    var total = quantity.attr('data-value');

    switch (action){
      case 'minus':
        if (total == 1){
          // total--;
          // quantity.attr('data-value',1).html(0);
          // parent.siblings('button').removeClass('selected').html('Quick Add');
        }else{
          total--;
          quantity.attr('data-value',total).html(total);
        }
      break;
      case 'plus':
        total++;
        quantity.attr('data-value',total).html(total);
      break;
    }

    let labelText = '';
    if (total > 1){
      labelText = label.attr('data-plural');
    }else{
      labelText = label.attr('data-singular');
    }

    let servings = total * parseInt(label.attr('data-basis'));
    let method = label.attr('data-method');

    let text = `${total} ${labelText} <span class="serving-method">(${servings} ${method})</span>`;
    label.html(text);
    $('.fon-heading-size span').html(text);
    $('.fon-heading-quantity span').html(total);

    
    computePrice(total);
    computeActiveQuantityBundle();

  });

  computePrice(1);

  function computePrice(quantity){

    var srpPrice = parseFloat($('.fon-quick-quantity-selector .label').attr('data-price'));
    var totalPrice = 0;
    switch (true) {
      case quantity === 2:
        totalPrice = srpPrice * 0.95 * quantity;
        break;

      case quantity === 3:
        totalPrice = srpPrice * 0.90 * quantity;
        break;

      case quantity >= 4:
        totalPrice = srpPrice * 0.85 * quantity;
        break;

      default:
        totalPrice = srpPrice;
    }
    $('#btn-add-to-cart').html(`
      <span>Add to Cart</span> -
      <strong class="add-to-cart-price with-currency-code">${totalPrice.toFixed(0)}</strong>
    `);
  }



  function computeActiveQuantityBundle(){

    
    var addToCartButtonBundle = $('#btn-add-to-cart');
    var total = 0;

    // $.each($('.bundle-save-products .btn-quick-add.selected'),function(){

    //   total+= parseFloat($(this).attr('data-quantity'));
      
    // });
    $.each($('.fon-quick-quantity-selector .quantity'),function(){
      total+= parseFloat($(this).attr('data-value'));
    });


    $('.cart-goal,.goal-progress').removeClass('matched');
    $('.cart-goal,.goal-progress').removeClass('active');
    $('.cart-goal,.goal-progress').removeClass('last-matched');
    
    $('.cart-goal,.goal-progress').each(function (index) {
      var spendValue = parseInt($(this).attr('data-quantity'), 10);
    
      if (total >= spendValue) {
        $(this).addClass('matched'); // optional: add class to highlight
      }
    });

    var lastMatched = $('.goals .cart-goal.matched').last();
    lastMatched.addClass('last-matched'); // Optional: mark or style it

    var lastMatched = $('.goals-progress > div.matched').last();
    lastMatched.addClass('last-matched'); // Optional: mark or style it
    
    $(".goals,.goals-progress").attr('data-matched',$('.cart-goal').length);

    if (total > 0){
      addToCartButtonBundle.prop('disabled',false);
    }else{
      addToCartButtonBundle.prop('disabled',true);
    }
    
  }

  
  // var productHandle =  $('.rd-product-information-wrapper').attr('data-rdev-product-handle');
  // console.warn('productHandle',productHandle);
  
  
  // /* Free Sachet Campaign */
  // let freeSachetCampaignStatus = false;
  // if ($('[data-free-sachet-campaign]').length){
  //   freeSachetCampaignStatus = true;
  // }

  
  // console.warn('freeSachetCampaignStatus',freeSachetCampaignStatus);
  // var freeSachetCampaignActiveFlavours = [];
  // var freeSachetFreeProduct = {};
  
  
  // // fetch('/discount/CLEAR');
  
  // var activeCurrency = 'AUD';
  // var activeCurrencyRate = 1;
  
  // if (typeof Shopify !== 'undefined' && Shopify.currency) {
  //     activeCurrency = Shopify.currency.active;
  //     activeCurrencyRate = Shopify.currency.rate;
    
  //     console.log('Active currency:', Shopify.currency.active);
  // } else {
  //     console.log('Shopify currency object not available.');
  // }

  // // alert(activeCurrency + ' ' + activeCurrencyRate);


  

  

  





  // $(document).on('click','.variant-quantity-label-selection',function(){

  //   $(this).addClass('active');
  //   $(this).siblings('.variant-quantity').find(".variant-add-quantity").click();
  // });



  
  // document.addEventListener('DOMContentLoaded', () => {
  //   document.querySelectorAll('video-media').forEach(media => {
  //     const video = media.querySelector('video');
  
  //     video.addEventListener('play', () => {
  //       media.classList.add('playing');
  //     });
  
  //     video.addEventListener('pause', () => {
  //       media.classList.remove('playing');
  //     });
  
  //     video.addEventListener('ended', () => {
  //       media.classList.remove('playing');
  //     });
  //   });
  // });
  

  // // $('.nutritional-item:first-child').addClass('active');
  // $(document).on('click','.nutritional-item',function(){
      
  //     if (!$(this).hasClass('active')){
  //       $('.nutritional-item').removeClass('active');
  //       $(this).addClass('active');
  //     }else{
  //       $(this).removeClass('active');
  //     }
      
  // });

  // // FAQ
  // // $(document).on('click','.faq',function(){
      
  // //     if (!$(this).hasClass('active')){
  // //       $('.faq').removeClass('active');
  // //       $(this).addClass('active');
  // //     }else{
  // //       $(this).removeClass('active');
  // //     }
      
  // // });


  // // More Info
  // $(document).on('click','.more-info',function(){
      
  //     if (!$(this).hasClass('active')){
  //       $('.more-info').removeClass('active');
  //       $(this).addClass('active');
  //     }else{
  //       $(this).removeClass('active');
  //     }
      
  // });

  
  
  // // Variant Quantity
  // $(document).on('click','.variant-add-quantity',function(){


  //     $('.product-subscription-widget').addClass('loaded');

  //     var inputContainer = $(this).siblings('.quantity-input-selector');
  //     var input = inputContainer.find('input');
    
  //     var currentQuantity = parseInt(input.val());
  //     var quantity = currentQuantity;
    
  //     if (currentQuantity === 0){
  //       $(this).parents('.variant-quantity').removeClass('variant-quantity-loaded');
  //     }


  //     // MAX 10
  //     if (currentQuantity === 9){
  //       $(this).parents('.variant-quantity').find('.variant-add-quantity').addClass('disable-add');
  //     }
  //     if (currentQuantity === 10){
          
  //     }else{
  //       quantity++;
  //       input.val(quantity);
  
  //       $(this).parents('.variant-quantity').find('.variant-count').html(quantity);
  
  //       computeAddToCart();
  //     }
    
      
    
  // });

  // $(document).on('click','.variant-minus-quantity',function(){
    

  //     var inputContainer = $(this).siblings('.quantity-input-selector');
  //     var input = inputContainer.find('input');
    
  //     var currentQuantity = parseInt(input.val());
  //     var quantity = currentQuantity;

  //     // Remove disable
  //     $(this).parents('.variant-quantity').find('.variant-add-quantity').removeClass('disable-add');
    
  //     if (currentQuantity === 1){
  //       $(this).parents('.variant-quantity').addClass('variant-quantity-loaded');

  //       // reset
  //       $(this).parents('.variant-quantity').siblings('.variant-quantity-label').removeClass('active');
        
  //     }

  //     quantity--;
  //     input.val(quantity);

  //     $(this).parents('.variant-quantity').find('.variant-count').html(quantity);


  //     computeAddToCart();
    
  // });

  // var totalItems = 0;
  // var totalAmountOneTime = 0;

  // var subscriptionOff = 15;
  // var totalAmountSubscription = 0;

  
  // var costPerServe = 0;
  // var items = [];

  // computeAddToCart();

  // window.addEventListener('pageshow', (event) => {
  //   if (event.persisted) {
  //     console.log('Page was restored from cache');
  //   }
  //   computeAddToCart();
  // });


  // function computeAddToCart(){

  //   // Remove sale price
  //   $('.price-sale').html('');
  //   $('.price-container').removeClass('price-sale-container');

  //   // $('.subscription-option.active .buy-now-checkout').find('.text').html('Checkout');


  //   // Let's overwrite if totalItems reached - NEW
  //   $('.variant-quantity-label-selection').removeClass('loaded');
  //   $('.variant-quantity-label-selection .variant-price-sale').html('');
    

  //   totalItems = 0;
  //   totalAmountOneTime = 0;
  //   totalAmountSubscription = 0;

  //   items = [];


  //   freeSachetCampaignActiveFlavours = [];

    
  //   $('.variant-quantity-selector').each(function() {


      
      
      
  //     var variantSKU = $(this).attr('data-variant-sku');
  //     var variantID = $(this).attr('data-variant-id');
  //     var priceData = parseInt($(this).attr('data-price')) ;
  //     var priceDataSubscription = parseInt($(this).attr('data-selling-plan-price'));


      
  //     var priceOneTime = (priceData / 100);
  //     var priceSubscription = (priceDataSubscription / 100);

      



  //     var sellingPlanID = $(this).attr('data-selling-plan-id');
      
      
  //     var currentQuantity = parseInt($(this).val()) || 0;


  //     $(this).parents('.variant-quantity').removeClass('singular plural');

  //     let orderType = $(this).parents('.variant-quantity').siblings('.variant-quantity-label').attr('data-action');

      
  //     let isPreOrder = (orderType === 'Pre-order') ? 'Yes' : 'No';

  //     console.log(variantID + ' isPreOrder',isPreOrder);
      
      
  //     if (currentQuantity > 0){


  //       // Free Sachet - Set Flavour
  //       var freeSachetFlavour = $(this).attr('data-free-sachet-variant-flavour');
  //       if (!freeSachetCampaignActiveFlavours.includes(freeSachetFlavour)) {
  //           freeSachetCampaignActiveFlavours.push(freeSachetFlavour);
  //       }

        
  //       $(this).parents('.variant-quantity').removeClass('variant-quantity-loaded');

  //       if (currentQuantity === 1){
  //         $(this).parents('.variant-quantity').addClass('singular');
  //       }else{
  //        $(this).parents('.variant-quantity').addClass('plural');
  //       }
  //     }
      
  //     var subTotalOneTime = toTwoDecimals(priceOneTime  * currentQuantity );
  //     var subTotalSubscription = toTwoDecimals( priceSubscription * currentQuantity );

  //     // Check if 12 months supply
  //     let isSubscription12MonthsActive = $('.subscription-option[data-type="elite"]').hasClass('active');
  //     if (isSubscription12MonthsActive){
  //       variantID = $('.variant-12-months-supply[data-sku="' + variantSKU + '"]').attr('data-variant-id'); 
  //       sellingPlanID = $('.variant-12-months-supply[data-sku="' + variantSKU + '"]').attr('data-selling-plan-id'); 
  //     }
      
      
      
  //     if (currentQuantity > 0){

  //       items.push({
  //         variantID: variantID,
  //         variantSKU: variantSKU,
  //         priceOneTimeOriginal: priceOneTime,
  //         priceOneTime: priceOneTime,
  //         priceSubscription: priceSubscription,
  //         quantity: currentQuantity,
  //         subTotalOnetime: subTotalOneTime,
  //         subTotalSubscription: subTotalSubscription,
  //         sellingPlanID: sellingPlanID,
  //         isPreOrder: isPreOrder
  //       });
  
  
  //       totalItems+=currentQuantity;
  //       totalAmountOneTime+=subTotalOneTime;
  //       totalAmountSubscription+=subTotalSubscription;
        
  //     }


      

      
      
  //   });



  //   // Dynamic pricing for quantity based discount === 1
  //     if (totalItems == 1){

  //       $('.variant-quantity-selector').each(function() {
  //         let variantParentOption = $(this).parents('.variant-option');
  //         let variantPriceLabelContainer = variantParentOption.find('.variant-quantity-label-selection');
  //         let variantPriceOG = variantParentOption.find('.variant-price-og');
  //         let variantPriceSale = variantParentOption.find('.variant-price-sale');
    
  //         let variantPriceOGValue = parseFloat(variantPriceOG.html());
  //         let variantPriceSaleValue = parseInt($(this).attr('data-selling-plan-price')) / 100;
    
  //         let variantPriceSaleValueOneTime = variantPriceOGValue;
  //         let variantPriceSaleValueSubscription = variantPriceOGValue;
    
  //         variantPriceSaleValueOneTime = variantPriceSaleValueOneTime - (variantPriceSaleValueOneTime * .05);
    
          
  //         switch (productHandle){
  //           case 'onefit':
  //           case 'onefit-sp1':
  //             variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (variantPriceSaleValueSubscription * .05); // Dynamic Price
  //             break;
  //           case 'bundle':
  //             variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (5 * activeCurrencyRate); // Dynamic Price
  //             break;
  //           default:
  //             variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (5 * activeCurrencyRate); // Dynamic Price
  //         }
    
    
  //         // Update Price - Dynamic Price
  //         variantPriceLabelContainer.addClass('loaded');   
  
  //         if ($('.subscription-option').attr('data-type') == 'subscription'){
  //           variantPriceSale.html(Math.floor(variantPriceSaleValueSubscription));
  //         }else{
  //           variantPriceSale.html(Math.floor(variantPriceSaleValueOneTime));
  //         }

         
          

          
  //       });
  //     }


  //   console.log('items',items);
  //   console.log('totalItems',totalItems);

  //   // Reset - hide price
  //   if (totalItems == 0){
  //     $('.product-subscription-widget').removeClass('loaded');
  //   }

  //   console.log('totalAmountOneTime',totalAmountOneTime);
  //   console.log('totalAmountSubscription',totalAmountSubscription);

  //   $('#btn-buy-now').prop('disabled',true);
  //   if (totalItems > 0){
  //     $('#btn-buy-now').prop('disabled',false);
  //   }

  //   var costPerServeOneTime = (totalAmountOneTime / totalItems) / serveBasic;
  //   var costPerServeSubscription = (totalAmountSubscription / totalItems) / serveBasic;

  //   if (totalAmountOneTime > 0){
    
  //     $('.subscription-option[data-type="one-time"] .option-price .price').html(formatPrice(totalAmountOneTime));
  //     $('.subscription-option[data-type="subscription"] .option-price .price').html(formatPrice(totalAmountSubscription));
      
  //     $('.subscription-option[data-type="one-time"] .option-price .serve span').html(costPerServeOneTime.toFixed(2));
  //     $('.subscription-option[data-type="subscription"] .option-price .serve span').html(costPerServeSubscription.toFixed(2));


  //      // Set Sticky State Default value
  //     $('.state-choose-plan .state-price-sale').html(formatPrice(totalAmountSubscription));
  //       $('.state-choose-plan .state-price-og').html(formatPrice(totalAmountOneTime));
      


  //      $('.price-note span').html(totalAmountSubscription.toFixed(2));


  //       // Save amount
  //       const saveAmount = totalAmountOneTime - totalAmountSubscription;
  //       $('.save-amount').html(Math.round(saveAmount));

      
  //     // Discount indicators
  //     setDiscountIndicator(totalItems);

  //   }

    
  

  //   if (totalItems >= 2){
      
  //     items = [];
  //     totalAmountOneTime = 0;
  //     totalAmountSubscription = 0;
      
  //     $('.variant-quantity-selector').each(function() {

  //       var variantSKU = $(this).attr('data-variant-sku');
  //       var variantID = $(this).attr('data-variant-id');
  //       var priceData = parseInt($(this).attr('data-price')) ;
  //       var priceDataSubscription = parseInt($(this).attr('data-selling-plan-price'));
  //       var priceOneTime = (priceData / 100);
  //       var priceOneTimeOriginal =  priceOneTime;
  //       var priceSubscription = (priceDataSubscription / 100);
  //       var originalPriceSubscription = priceSubscription;

  //       let orderType = $(this).parents('.variant-quantity').siblings('.variant-quantity-label').attr('data-action');
  //       let isPreOrder = (orderType === 'Pre-order') ? 'Yes' : 'No';
  //       console.log(variantID + ' isPreOrder',isPreOrder);
        


  //       // Dynamic pricing for quantity based discount
  //       let variantParentOption = $(this).parents('.variant-option');
  //       let variantPriceLabelContainer = variantParentOption.find('.variant-quantity-label-selection');
  //       let variantPriceOG = variantParentOption.find('.variant-price-og');
  //       let variantPriceSale = variantParentOption.find('.variant-price-sale');

  //       let variantPriceOGValue = parseFloat(variantPriceOG.html());

  //       let variantPriceSaleValueOneTime = variantPriceOGValue;
  //       let variantPriceSaleValueSubscription = variantPriceOGValue;
        
  
  //       switch (true) {
  //         case totalItems === 2:
  //           priceOneTime = priceOneTime - (priceOneTime * .05);
            
  //           variantPriceSaleValueOneTime = variantPriceSaleValueOneTime - (variantPriceSaleValueOneTime * .10);
            
  //           // priceSubscription-= (5 * activeCurrencyRate);

  //           switch (productHandle){
  //             case 'onefit':
  //             case 'onefit-sp1':
  //               priceSubscription = priceSubscription - (priceSubscription * .05);
  //               variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (variantPriceSaleValueSubscription * .10); // Dynamic Price
  //               break;
  //             case 'bundle':
  //               variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (20 * activeCurrencyRate); // Dynamic Price
  //               break;
  //             default:
  //               priceSubscription-= (5 * activeCurrencyRate);
  //               variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (10 * activeCurrencyRate); // Dynamic Price
  //           }

            
  //         break;
  //         case totalItems === 3:
  //           priceOneTime = priceOneTime - (priceOneTime * .10);
  //           variantPriceSaleValueOneTime = variantPriceSaleValueOneTime - (variantPriceSaleValueOneTime * .10);
  //           // priceSubscription-= (10 * activeCurrencyRate);
            
  //           switch (productHandle){
  //             case 'onefit':
  //             case 'onefit-sp1':
  //               priceSubscription = priceSubscription - (priceSubscription * .10);
  //               variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (variantPriceSaleValueSubscription * .15); // Dynamic Price
  //               break;
  //             case 'bundle':
  //               priceSubscription-= (20 * activeCurrencyRate);
  //               variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (40 * activeCurrencyRate); // Dynamic Price
  //               break;
  //             default:
  //               priceSubscription-= (10 * activeCurrencyRate);
  //               variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (15 * activeCurrencyRate); // Dynamic Price
  //           }
  //         break;
  //         case totalItems >= 4:
  //           priceOneTime = priceOneTime - (priceOneTime * .15);
  //           variantPriceSaleValueOneTime = variantPriceSaleValueOneTime - (variantPriceSaleValueOneTime * .15);
  //           // priceSubscription-= (15 * activeCurrencyRate);

  //           switch (productHandle){
  //             case 'onefit':
  //             case 'onefit-sp1':
  //               priceSubscription = priceSubscription - (priceSubscription * .15);
  //               variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (variantPriceSaleValueSubscription * .15); // Dynamic Price
  //               break;
  //             case 'bundle':
  //               priceSubscription-= (40 * activeCurrencyRate);
  //               variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (40 * activeCurrencyRate); // Dynamic Price
  //               break;
  //             default:
  //               priceSubscription-= (15 * activeCurrencyRate);
  //               variantPriceSaleValueSubscription = variantPriceSaleValueSubscription - (15 * activeCurrencyRate); // Dynamic Price
  //           }
            
  //         break;
  //         default:
  //           console.log('Invalid selection');
  //       }

  //       // Update Price - Dynamic Price
  //       variantPriceLabelContainer.addClass('loaded');   

  //       if ($('.subscription-option').attr('data-type') == 'subscription'){
  //         variantPriceSale.html(Math.floor(variantPriceSaleValueSubscription));
  //       }else{
  //         variantPriceSale.html(Math.floor(variantPriceSaleValueOneTime));
  //       }
        
        

  //       console.warn('this is working',variantID + ' / ' + priceSubscription + ' / orig ' + originalPriceSubscription);
        
  
  //       var sellingPlanID = $(this).attr('data-selling-plan-id');
  //       var currentQuantity = parseInt($(this).val()) || 0;
  //       var subTotalOneTime = toTwoDecimals(priceOneTime  * currentQuantity );
  //       var subTotalSubscription = toTwoDecimals( priceSubscription * currentQuantity );

  //       console.warn('subTotalSubscription',subTotalSubscription);


  //       // Check if 12 months supply
  //       let isSubscription12MonthsActive = $('.subscription-option[data-type="elite"]').hasClass('active');
  //       if (isSubscription12MonthsActive){
  //         variantID = $('.variant-12-months-supply[data-sku="' + variantSKU + '"]').attr('data-variant-id'); 
  //         sellingPlanID = $('.variant-12-months-supply[data-sku="' + variantSKU + '"]').attr('data-selling-plan-id'); 
  //       }
  
  //       if (currentQuantity > 0){
  
  //         items.push({
  //           variantID: variantID,
  //           variantSKU: variantSKU,
  //           priceOneTime: priceOneTime,
  //           priceOneTimeOriginal: priceOneTimeOriginal,
  //           priceSubscription: priceSubscription,
  //           quantity: currentQuantity,
  //           subTotalOnetime: subTotalOneTime,
  //           subTotalSubscription: subTotalSubscription,
  //           sellingPlanID: sellingPlanID,
  //           isPreOrder: isPreOrder
  //         });
    
  //         totalAmountOneTime+=subTotalOneTime;
  //         totalAmountSubscription+=subTotalSubscription;
          
  //       }
  
  //     });


  //     var costPerServeOneTime = (totalAmountOneTime / totalItems) / serveBasic;
     
      
  //     var costPerServeSubscription = (totalAmountSubscription / totalItems) / serveBasic;

  //     console.log('totalAmountSubscription',totalAmountSubscription);
  
  //     if (totalAmountOneTime > 0){

  //       // Update Sale
  //       // $('.subscription-option[data-type="one-time"] .option-price .price').html(totalAmountOneTime.toFixed(2));
  //       // $('.subscription-option[data-type="subscription"] .option-price .price').html(totalAmountSubscription.toFixed(2));
  //       $('.subscription-option[data-type="one-time"] .option-price .price').html(formatPrice(totalAmountOneTime));
  //     $('.subscription-option[data-type="subscription"] .option-price .price').html(formatPrice(totalAmountSubscription));
        
  //       $('.subscription-option[data-type="one-time"] .option-price .serve span').html(costPerServeOneTime.toFixed(2));
  //       $('.subscription-option[data-type="subscription"] .option-price .serve span').html(costPerServeSubscription.toFixed(2));

  //       $('.state-choose-plan .state-price-sale').html(formatPrice(totalAmountSubscription));
  //       $('.state-choose-plan .state-price-og').html(formatPrice(totalAmountOneTime));

        

  //       $('.price-container').addClass('price-sale-container');

  //       $('.price-note span').html(totalAmountSubscription.toFixed(2));

        
  //       // Save amount
  //       const saveAmount = totalAmountOneTime - totalAmountSubscription;
  //       $('.save-amount').html(Math.round(saveAmount));
  
  //     }


      


      
  //   }



  //   console.log('freeSachetCampaignActiveFlavours',freeSachetCampaignActiveFlavours);
  //   // Check if more than 2 flavours
  //   freeSachetFreeProduct = {};
  //   if (freeSachetCampaignActiveFlavours.length === 1){

      

  //     var primaryFlavour = freeSachetCampaignActiveFlavours[0];
      
  //     console.log("freeSachetCampaign Initiated");
  //     console.log("Main flavour is " + primaryFlavour);

  //     // Get free product variant id
  //     var freeSachetVariantID = $('[data-free-sachet-variant-flavour="' + primaryFlavour + '"]').first().attr('data-free-sachet-free-variant-id');
  //     console.log("Sachet free variant id is " + freeSachetVariantID);

  //     freeSachetFreeProduct = {
  //       id: freeSachetVariantID,
  //       quantity: 1,
  //     };
      
  //   }

  //   $('#multi-variant-container').attr('data-total-items',totalItems);


  //   // twelve-month-content
  //   if (totalItems == 0){
  //     $('.product-subscription-widget').addClass('no-selection');
  //     $('.twelve-month-content').removeClass('with-active-selections');
  //   }else{
  //     $('.product-subscription-widget').removeClass('no-selection');
  //     var twelveMonthYearLabel = [];
  //     var twelveMonthQuarterLabel = [];

  //     var twelveMonthCost = 0;
  //     //price-static
      
  //     $.each(items,function(index,item){
  //       console.log('item',item);

        

  //       let labelYearly = '';
  //       let labelQuaterly = '';

  //       let itemQuantity = parseInt(item.quantity);
        
  //       if (itemQuantity > 0){


  //         let discountedPrice = ( (parseFloat(item.priceOneTimeOriginal) ) * .80);
          
  //         twelveMonthCost+= (discountedPrice * itemQuantity * 12);
          
  //         console.log('twelveMonthCost',twelveMonthCost);
  //         console.log('twelveMonthCost priceOneTimeOriginal',item.priceOneTimeOriginal);

  //        console.log('twelveMonthItem',item);

          
  //         if (itemQuantity == 1){
            
  //           let text = '12 ' + labelConverter(item.variantSKU);
  //           twelveMonthYearLabel.push(text);

            
  //           let textQuarterly = '3 ' + labelConverter(item.variantSKU);
  //           twelveMonthQuarterLabel.push(textQuarterly);
            
  //         }else{

  //           let text = (12 * itemQuantity) + ' ' + labelConverter(item.variantSKU);
  //           twelveMonthYearLabel.push(text);

  //           let textQuarterly = ((12 * itemQuantity) / 4) + ' ' + labelConverter(item.variantSKU);
  //           twelveMonthQuarterLabel.push(textQuarterly);
            
  //         }
  //       }
  //     });

  //     console.log('twelveMonthQuarterLabel',twelveMonthQuarterLabel);
  //     console.log('twelveMonthYearLabel',twelveMonthYearLabel);

  //     $('.twelve-month-buying-info .twelve-month-product-names').html(formatTwelveMonthLabels(twelveMonthYearLabel));
  //     $('.twelve-month-delivery .twelve-month-product-names').html(formatTwelveMonthLabels(twelveMonthQuarterLabel));

      
  //     $('.twelve-month-content').addClass('with-active-selections');
  //     $('.price-static-twelve-months').html(twelveMonthCost.toFixed(2));

  //     // June 19, 2025 - Fix
  //     var perServe = ((twelveMonthCost.toFixed(2) / (12 * totalItems) ) ) / 20;
  //     $('.twelve-month-per-serve').html(perServe.toFixed(2));
      
  //   }

  //   // June 19, 2025 - Fix
  //   if ($('body').hasClass('body-non-au') && !$('body').hasClass('body-non-au-triggered')){
  //     $('body').addClass('body-non-au-triggered');
  //     $('.subscription-option[data-type="one-time"]').addClass('active');
  //   }
   
    
  // }


  // function formatPrice(amount) {
  //   return amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
  // }

  
  // function formatTwelveMonthLabels(items) {
  //    if (!items || items.length === 0) return '';
    
  //     if (items.length === 1) {
  //       return `${items[0]}`;
  //     }
    
  //     const allButLast = items.slice(0, -1).map(item => `${item}`).join(', ');
  //     const lastItem = `${items[items.length - 1]}`;
    
  //     return `${allButLast} & ${lastItem}`;
  // }

  
  // function labelConverter(sku){

  //   let label = 'Not set - ' + sku;
  //   switch (sku){
  //     case 'OF-CH-BOX-20-V4.5':
  //       label = 'Choc Boxes';
  //     break;
  //     case 'OF-CH-TIN-700-V4.5':
  //       label = 'Choc Tins';
  //     break;
  //     case 'OF-OP-BOX-20-V4.5':
  //       label = 'Pine Orange Boxes';
  //     break;
  //     case 'OF-OP-TIN-700-V4.5':
  //       label = 'Pine Orange Tins';
  //     break;
  //   }

  //   return label;
    
  // }
  // function setDiscountIndicator(quantity){
  //   $('.discount-indicators .discount').removeClass('active');
  
  //   switch (true) {
  //     case quantity === 2:
  //       $('.discount-indicators .discount[data-count="2"]').addClass('active');
  //       break;
  //     case quantity === 3:
  //       $('.discount-indicators .discount[data-count="3"]').addClass('active');
  //       break;
  //     case quantity >= 4:
  //       $('.discount-indicators .discount[data-count="4"]').addClass('active');
  //       break;
  //     default:
  //       console.log('Invalid selection');
  //   }
    
  // }
  // function toTwoDecimals(value) {
  //   const num = parseFloat(value);
  //   if (isNaN(num)) {
  //     throw new Error('Invalid number');
  //   }
  //   return Math.round(num * 100) / 100;
  // }


  // $(document).on('click','.subscription-option',function(){

  //     var parent = $(this).parents('.product-subscription-widget');
    
  //     if (parent.hasClass('no-selection')){
  //       const target = document.getElementById("block-product-ingredients");
  //       target.scrollIntoView({ behavior: "smooth" });
  //     }else{
  //       $('.subscription-option').removeClass('active');
  //       $(this).addClass('active');
  
  //       // Change dynamic price
      
  //       const purchaseOptionType = $(this).attr('data-type');
      
  //       $('.variant-quantity-label-selection').removeClass('loaded');
  //       $('.variant-quantity-label-selection .variant-price-sale').html('');
      
  //       $('.variant-quantity-selector').each(function() {
    
  //         // Dynamic pricing for quantity based discount
  //         let variantParentOption = $(this).parents('.variant-option');
  
  
  //         let variantPriceOG = variantParentOption.find('.variant-price-og');
  //         let variantPriceSale = variantParentOption.find('.variant-price-sale');
  
          
          
          
  //         if (purchaseOptionType === 'subscription'){
  //           variantPriceOG.html(variantPriceOG.attr('data-variant-subscription-price'));
  //         }else{
  //           variantPriceOG.html(variantPriceOG.attr('data-variant-one-time-price'));
  //         }
  
  
  //       });
  
  //       computeAddToCart();

  //       initPrices(); // June 19, 2025 - Fix
  //     }

      

  // });

  // $('#btn-buy-now').prop('disabled',true);

  // $(document).on('click','.subscription-option.active .buy-now-checkout',function(){

  //   if (!$(this).hasClass('processing')){
  //     $(this).addClass('processing');
  //     $(this).find('.text').html("Checking out...");


  //     // Update Selling Plan
  //     $('#selling-plan').trigger('change');


  //     fetch('/cart/clear.js', {
  //       method: 'POST'
  //     }).then(response => {
  //       if (response.ok) {

  //           processCart(items);
  //           //Reset new buy now

          
          
  //       }
  //     });
      
  //   }
    
    

  // });
    
  
  // $(document).on('click','#btn-buy-now',function(){
  //     var button = $(this);


  //     // Update Selling Plan
  //     $('#selling-plan').trigger('change');



  //     button.prop('disabled',true).html('Please wait...');

  //     fetch('/cart/clear.js', {
  //       method: 'POST'
  //     }).then(response => {
  //       if (response.ok) {

            
          
  //           processCart(items);
  //           button.prop('disabled',false).html('Buy Now');

  //         //Reset new buy now
  //           // $('.subscription-option.active .buy-now-checkout').removeClass('processing');

  //           // setTimeout(function(){
  //           //   $('.subscription-option.active .buy-now-checkout').find('.text').html('Checkout');
  //           // },1000);
            
          
  //       }
  //     });


    
  // });

  // function processCart(items){


      
  //     console.log('process items',items);
    
  //     const isSubscriptionActive = $('.subscription-option[data-type="subscription"]').hasClass('active');
  //     const isSubscription12MonthsActive = $('.subscription-option[data-type="elite"]').hasClass('active');
    
    
  //     var cartItems = [];
    
  //     $.each(items, function(index, item) {

  //         // If bundle exist
  //         if ($('.bundle-fulfillment-rules-' + item.variantID).length){

            
  //           var fulfillmentRules = $('.bundle-fulfillment-rules-' + item.variantID + ' .fulfillment-rule');
                
  //           $.each(fulfillmentRules,function(){


              
  //             var bundleVariantSellingPlanID = $(this).attr('data-bundle-selling-plan-id');
  //             var bundleVariantTitle = $(this).attr('data-bundle-variant-title');
  //             var bundleVariantID = $(this).attr('data-bundle-variant-id');
  //             var bundleVariantQuantity = $(this).attr('data-bundle-quantity');

  //             let properties = {};
  //             if (item.isPreOrder == 'Yes') {
  //                 properties["Order Type"] = "PRE-ORDER";
  //             }
              
  //             properties['Bundle'] = bundleVariantTitle;

  //             var lineItem = {
  //               id: parseInt(bundleVariantID),
  //               quantity: parseInt(bundleVariantQuantity) * item.quantity,
  //               properties: properties
  //             };
            
  //             if (isSubscriptionActive) {
                
  //               lineItem.selling_plan = $('#selling-plan').val(); //bundleVariantSellingPlanID; // Your selling plan ID
  //             }
            
  //             cartItems.push(lineItem);
              
              
  //           });

         
            
  //         }else{

            
  //                let properties = {};
  //                 if (item.isPreOrder == 'Yes') {
  //                     properties["Order Type"] = "PRE-ORDER";
  //                 }

  //             // isSubscription12MonthsActive
  //               let itemQuantity = item.quantity;

                
            
  //               var lineItem = {
  //                 id: item.variantID,
  //                 quantity: itemQuantity,
  //                 properties: properties
  //               };

  //               // Let's replace the variant id with the 12 months variants
  //               if (isSubscription12MonthsActive){
  //                 itemQuantity = itemQuantity * 3;
  //                 lineItem.quantity = itemQuantity;
  //               }
            
              
  //               if (isSubscriptionActive || isSubscription12MonthsActive) {
  //                 lineItem.selling_plan = item.sellingPlanID; // Your selling plan ID
  //               }
              
  //               cartItems.push(lineItem);

            
  //         }       
      

        
  //     });
      

  //     // Add Free Product
  //     if (isSubscriptionActive) {
  //       var lineItem = {
  //         id: 53301741289656,
  //         quantity: 1
  //       };
  //       cartItems.push(lineItem);
        
  //     }

  //     // Double Bottle
  //     if (isSubscription12MonthsActive) {
  //       var lineItem = {
  //         id: 53301741289656,
  //         quantity: 2
  //       };
  //       cartItems.push(lineItem);
        
  //     }

    

  //     // Free Sachet Product
  //     if (Object.keys(freeSachetFreeProduct).length > 0 && freeSachetCampaignStatus) {
  //       // cartItems.push(freeSachetFreeProduct);
  //     }

  //     console.debug('cartItems',cartItems);

    
  //     if (cartItems.length){
  //       // AJAX request to add multiple items to the cart

        
  //       fetch('/cart/add.js', {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({ items: cartItems })
  //       })
  //       .then(response => response.json())
  //       .then(data => {
  //         console.log('Items added to cart:', data);


     
          

  //         // if (isSubscriptionActive){
  //         //   // window.location.href = '/checkout?discount=MembersOnly';
  //         //   window.location.href = '/checkout';
  //         // }else{
  //         //   window.location.href = '/checkout';
  //         // }
  //         window.location.href = '/checkout';

          
  //           $('.subscription-option.active .buy-now-checkout').removeClass('processing');

  //           setTimeout(function(){
  //             $('.subscription-option.active .buy-now-checkout').find('.text').html('Checkout');
  //           },1000);
          
          
  //       })
  //       .catch(error => console.error('Error adding items to cart:', error));

        
  //     }else{
  //       alert('No selected products.');
        
  //     }
      
  
  // }



  
  // function initIngredientSwiper() {
  //   if ($(window).width() <= 768 && !$('.ingredients-container').hasClass('swiper-initialized')) {
  //     // Add Swiper classes
  //     $('.ingredients-container').addClass('swiper-container swiper-initialized');
  //     $('.ingredients-container').wrapInner('<div class="swiper-wrapper"></div>');
  //     $('.ingredient').addClass('swiper-slide');

  //     // Initialize Swiper
  //     new Swiper('.ingredients-container.swiper-container', {
  //       slidesPerView: 1.2,
  //       spaceBetween: 10,
  //       loop: true,
  //       pagination: {
  //         el: '.ingredients-container .swiper-pagination',
  //         clickable: true,
  //       },
  //     });

  //     // Add pagination
  //     $('.ingredients-container').append('<div class="swiper-pagination"></div>');
  //   } else if ($(window).width() > 768 && $('.ingredients-container').hasClass('swiper-initialized')) {
  //     // Remove Swiper on larger screens
  //     $('.ingredients-container').removeClass('swiper-container swiper-initialized');
  //     $('.swiper-wrapper').children().unwrap();
  //     $('.ingredient').removeClass('swiper-slide');
  //     $('.swiper-pagination').remove();
  //   }
  // }

  // // Initialize on load
  // initIngredientSwiper();





  
  // function initSwiperOnMobile(key, slidesPerView = 1.2) {
  //   const parentElement = $(key);
  
  //   if ($(window).width() <= 768 && !parentElement.hasClass('swiper-initialized')) {
  //     // Add Swiper classes
  //     parentElement.addClass('swiper-container swiper-initialized');
  //     parentElement.children().wrapAll('<div class="swiper-wrapper"></div>');
  //     parentElement.find('.swiper-wrapper').children().addClass('swiper-slide');
  
  //     // Initialize Swiper
  //     new Swiper(key, {
  //       slidesPerView: slidesPerView,
  //       spaceBetween: 10,
  //       loop: true,
  //       autoplay: {
  //         delay: 3000, // 3 seconds
  //         disableOnInteraction: false, // Keep autoplay active after interaction
  //       },
  //       // pagination: {
  //       //   el: key + ' .swiper-pagination',
  //       //   clickable: true,
  //       // },
  //     });
  
  //     // Add pagination if not exists
  //     if (!parentElement.find('.swiper-pagination').length) {
  //       parentElement.append('<div class="swiper-pagination"></div>');
  //     }
  //   } else if ($(window).width() > 768 && parentElement.hasClass('swiper-initialized')) {
  //     // Destroy Swiper instance and reset structure
  //     parentElement.removeClass('swiper-container swiper-initialized');
  //     const slides = parentElement.find('.swiper-slide').unwrap(); // unwrap from swiper-wrapper
  //     slides.removeClass('swiper-slide');
  //     parentElement.find('.swiper-pagination').remove();
  //   }
  // }
  


  
  


  // function initSwiperOnMobileNatural(key, slidesPerView = 1.2) {
  //   const parentElement = $(key);
  
  //   if ($(window).width() <= 768 && !parentElement.hasClass('swiper-initialized')) {
  //     // Add Swiper classes
  //     parentElement.addClass('swiper-container swiper-initialized');
  //     parentElement.children().wrapAll('<div class="swiper-wrapper"></div>');
  //     parentElement.find('.swiper-wrapper').children().addClass('swiper-slide');
  
  //     // Initialize Swiper
  //     new Swiper(key, {
  //       slidesPerView: 3,
  //       spaceBetween: 10,
  //       loop: true,
  //       speed: 1500, // No transition, instant slide change
  //       autoplay: {
  //         delay: 0, // 3 seconds
  //         disableOnInteraction: false, // Keep autoplay active after interaction
  //       },
  //       // pagination: {
  //       //   el: key + ' .swiper-pagination',
  //       //   clickable: true,
  //       // },
  //     });
  
  //     // Add pagination if not exists
  //     if (!parentElement.find('.swiper-pagination').length) {
  //       parentElement.append('<div class="swiper-pagination"></div>');
  //     }
  //   } else if ($(window).width() > 768 && parentElement.hasClass('swiper-initialized')) {
  //     // Destroy Swiper instance and reset structure
  //     parentElement.removeClass('swiper-container swiper-initialized');
  //     const slides = parentElement.find('.swiper-slide').unwrap(); // unwrap from swiper-wrapper
  //     slides.removeClass('swiper-slide');
  //     parentElement.find('.swiper-pagination').remove();
  //   }
  // }
  // initSwiperOnMobileNatural('.section-natural-delicious .features-container',3);


  
  //  // Selling Plan
  // $('#selling-plan option').sort(function(a, b) {
  //   const getDays = text => parseInt(text.match(/\d+/));
  //   return getDays(a.textContent) - getDays(b.textContent);
  // }).appendTo('#selling-plan');

  

  // // Selling Plan Selector
  // const $defaultPlanOption = $('[data-plan-name="Ships every 30-days"]');
  
  // if ($defaultPlanOption.length) {
  //   $defaultPlanOption.prop('selected', true).closest('select').trigger('change');
  //   const sellingPlanId = $defaultPlanOption.val();
  //   $('.variant-quantity-selector').attr('data-selling-plan-id', sellingPlanId);
  // }


  // document.addEventListener('scroll', function () {
  //   const title = document.querySelector('.rd-product-information-wrapper');
  //   const body = document.body;

  //   if (!title) return;

  //   const titleTop = title.getBoundingClientRect().top;

  //   if (titleTop <= 0) {
  //     body.classList.add('scrolled-to-title');
  //   } else {
  //     body.classList.remove('scrolled-to-title');
  //   }
  // });


  // // Get Initial Prices
  // initPrices();

  // function initPrices(){
  //   $.each($('.flavour'),function(){
  //     var variantID = $(this).attr('data-variant-id');
  //     var targetVariantInput = $('.variant-option input[data-variant-id="'+variantID+'"]');
  //     var targetVariantOption = targetVariantInput.parents('.variant-option');

  //     var price = targetVariantOption.find('[data-variant-subscription-price]').attr('data-variant-subscription-price');


  //     // One Time price
  //     price = $(this).find('.flavour-price').attr('data-flavour-variant-subscription-price');

      
  //     // Disable dynamic pricing
  //     // var priceElement = targetVariantOption.find('.variant-price-sale');
  //     // var priceHtml = priceElement.html();
      
  //     // if (priceHtml && priceHtml.trim() !== '') {
  //     //   price = priceHtml.trim();
  //     // }



  //     // June 19, 2025 - Fix (Next offer price for USD)
  //     if ( $('body').hasClass('body-non-au') || $('body').hasClass('country-US') ){
  //     // if ( $('body').hasClass('body-non-au') || $('body').hasClass('body-non-au-trigerred') || $('.subscription-option[data-type="one-item"]').hasClass('active') ){
        
  //       price = $(this).find('.flavour-price').attr('data-flavour-variant-one-time-price');
  //       price = parseFloat(price);
        
  //       // var totalItems = $('#multi-variant-container').attr('data-total-items');

  //       // totalItems = parseInt(totalItems);

  //       // switch (true){
  //       //   case totalItems == 1:
  //       //     price = price * .95;
  //       //   break;

  //       //   case totalItems == 2:
  //       //     price = price * .90;
  //       //   break;

  //       //   case totalItems == 3:
  //       //     price = price * .85;
  //       //   break;

  //       //   case totalItems >= 4:
  //       //     price = price * .85;
  //       //   break;
            
  //       // }
        
  //       price = price.toFixed(2);
  //     }

      
      
  //     $(this).find('.flavour-price span').html(price);
  //   });


  //   $('.packaging-type-052025 .packaging-group').each(function(){
      
  //     var totalSelected = 0;
  //     var flavours = $(this).find('.flavour');
    
  //     $.each(flavours, function(){
  //       var variantID = $(this).attr('data-variant-id');
        
  //       var variantOption = $('.variant-option input[data-variant-id="'+variantID+'"]');

  //       console.log('variantID',variantID);
  //       console.log('variantOption.val()',variantOption.val());
  //       totalSelected+= parseInt(variantOption.val() || 0);
  //     });

  //     console.log('totalSelected',totalSelected);

  //     var totalSelectedLabel = (totalSelected <= 1) ? 'SELECTION' : 'SELECTIONS';
  //     var totalSelectedHTML = totalSelected + ' ' + totalSelectedLabel;
      
  //     if ($(this).hasClass('sachets')){
  //         totalSelectedLabel = (totalSelected <= 1) ? 'BOX SELECTED' : 'BOXES SELECTED';
  //         totalSelectedHTML = totalSelected + ' ' + totalSelectedLabel;
  //     }else{
  //        totalSelectedLabel = (totalSelected <= 1) ? 'TIN SELECTED' : 'TINS SELECTED';
  //        totalSelectedHTML = totalSelected + ' ' + totalSelectedLabel;
  //     }
      
      

  //     $(this).find('.selection').html(totalSelectedHTML).hide().removeClass('selection-active');
  //     if (totalSelected > 0){
  //       $(this).find('.selection').show().addClass('selection-active');
  //     }
      
  //   });
  //   // .variant-quantity-selector-052025
  // }

  

  // $(document).on('click','.flavour .flavour-image .btn-select',function(){

  //   var parent = $(this).parents('.flavour');
  //   parent.addClass('selected');
    
  //   var variantID = parent.attr('data-variant-id');
  //   var targetVariantInput = $('.variant-option input[data-variant-id="'+variantID+'"]');
  //   var targetVariantOption = targetVariantInput.parents('.variant-option');
  //   var targetVariantButton = targetVariantOption.find('.variant-quantity-label');

  //   targetVariantButton.trigger('click');

  //   var variantCount = parent.find('.variant-count');
  //   variantCount.html(targetVariantInput.val());

  //   initPrices();
    
  // });

  // $(document).on('click','.packaging-type-052025 > div',function(){
  //   $('.packaging-type-052025 > div').removeClass('active');
  //   $(this).addClass('active');
  // });


  // $(document).on('click','.flavour .flavour-image .variant-quantity-button-052025',function(){

  //     var parent = $(this).parents('.flavour');
  //     var action = $(this).attr('action');

  //     var btnSelect = parent.find('.btn-select');
  //     var variantCount = parent.find('.variant-count');
  //     var variantID = parent.attr('data-variant-id');


  //     var targetVariantInput = $('.variant-option input[data-variant-id="'+variantID+'"]');
  //     var targetVariantOption = targetVariantInput.parents('.variant-option');
  //     var targetVariantAdd = targetVariantOption.find('[action="add"]');
  //     var targetVariantMinus = targetVariantOption.find('[action="minus"]');

      
    
  //     switch(action){
  //       case 'add':
  //         targetVariantAdd.trigger('click');
  //       break;
  //       case 'minus':
  //         targetVariantMinus.trigger('click');
          
  //       break;
  //     }


  //   if (targetVariantInput.val() == 0){
  //     parent.removeClass('selected');
  //   }

  //   if (targetVariantInput.val() > 1){
  //     parent.addClass('enable-plural');
  //   }else{
  //     parent.removeClass('enable-plural');
      
  //   }
  //   variantCount.html(targetVariantInput.val());
    
  //   initPrices();
    
  // });


  $('.open-supplement-facts').magnificPopup({
    type: 'inline',
    callbacks: {
          open: function() {
              console.log('Popup body-inline-bottom');
              $('body').addClass('body-popup-slide');
          },
          close: function() {
              console.log('Popup closed');
              $('body').removeClass('body-popup-slide');
          }
    },
    mainClass: 'mfp-animate-bottom',
    closeMarkup: `
      <button title="%title%" type="button" class="mfp-close">
        <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
          <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
        </svg>
      </button>
    `
  });

 
  
});